export enum EHintType {
  RESERVE = 'RESERVE',
  OTHER_VOLUMES = 'OTHER_VOLUMES',
  LAYER_THICKNESS = 'LAYER_THICKNESS',
  TWO_LAYERS = '2_LAYERS',
}
